// extracted by mini-css-extract-plugin
export default {"heading":"Cy-z","corrected":"Dy-z","redirectVerbiageContainer":"Ey-z","redirectVerbiageText":"Fy-z"};